import { useEffect, useState } from "react";
import Table from "../../components/Table.js";
import Header from "../../components/Header.js";
import { useNavigate } from "react-router-dom";
import { getAllUsers } from "../../services/authServices.js";
import { useAuth } from "../../context/AuthContext.js";
import { Eye, SquarePen, Trash2, UserRoundPen } from "lucide-react";

function ValidatorsSettings() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const { user } = useAuth();
  const [validators, setValidators] = useState([]);

  const validatorData = [
    {
      name: "Lorem ipsum 1",
      assigned: 10,
      pending: 6,
      approved: 2,
      rejected: 2,
      profile: "view1",
    },
    {
      name: "Lorem ipsum 2",
      assigned: 10,
      pending: 6,
      approved: 2,
      rejected: 2,
      profile: "view2",
    },
    {
      name: "Lorem ipsum 3",
      assigned: 10,
      pending: 6,
      approved: 2,
      rejected: 2,
      profile: "view3",
    },
    {
      name: "Lorem ipsum 4",
      assigned: 10,
      pending: 6,
      approved: 2,
      rejected: 2,
      profile: "view4",
    },
    {
      name: "Lorem ipsum 5",
      assigned: 10,
      pending: 6,
      approved: 2,
      rejected: 2,
      profile: "view5",
    },
    {
      name: "Lorem ipsum 6",
      assigned: 10,
      pending: 6,
      approved: 2,
      rejected: 2,
      profile: "view6",
    },
    {
      name: "Lorem ipsum 7",
      assigned: 10,
      pending: 6,
      approved: 2,
      rejected: 2,
      profile: "view7",
    },
    {
      name: "Lorem ipsum 8",
      assigned: 10,
      pending: 6,
      approved: 2,
      rejected: 2,
      profile: "view8",
    },
  ];

  const columns = [
    { label: "Validator Name", key: "name", align: "center" },
    {
      label: "Assigned",
      key: "assigned",
      align: "center",
      render: (row) => (
        <div className={`font-semibold rounded-full text-center `}>
          {row.pending}
        </div>
      ),
      className: "bg-[#d7dcfb] text-gray-700",
    },
    {
      label: "Pending",
      key: "pending",
      align: "center",
      render: (row) => (
        <div
          className={`font-semibold rounded-full text-center ${
            row.pending > 0
              ? "bg-yellow-100 text-yellow-700"
              : "bg-gray-100 text-gray-700"
          }`}
        >
          {row.pending}
        </div>
      ),
      className: "bg-yellow-100 text-yellow-700",
    },
    {
      label: "Approved",
      key: "approved",
      align: "center",
      render: (row) => (
        <div
          className={`font-semibold rounded-full text-center ${
            row.approved > 0
              ? "bg-green-100 text-green-700"
              : "bg-gray-100 text-gray-700"
          }`}
        >
          {row.approved}
        </div>
      ),
      className: "bg-green-100 text-green-700",
    },
    {
      label: "Rejected",
      key: "rejected",
      align: "center",
      render: (row) => (
        <div
          className={`font-semibold rounded-full text-center ${
            row.rejected > 0
              ? "bg-red-100 text-red-700"
              : "bg-gray-100 text-gray-700"
          }`}
        >
          {row.rejected}
        </div>
      ),
      className: "bg-red-100 text-red-700",
    },
    {
      label: "Action",
      key: "profile",
      align: "center",
      render: (row) => (
        <>
          <button
            className="text-indigo-600 hover:text-indigo-900 cursor-pointer mr-3"
            onClick={(e) => {
              e.preventDefault();
              navigate(`/validators/profile?user=${row.id}`);
            }}
          >
            <Eye />
            <span className="sr-only">View profile for {row.name}</span>
          </button>
          {/* <button
            className="text-indigo-600 hover:text-indigo-900 cursor-pointer mx-1"
            onClick={(e) => {
              e.preventDefault();
              navigate(`/validators/change-validator-password?user=${row.id}`);
            }}
          >
            <SquarePen />
            <span className="sr-only">Change password for {row.name}</span>
          </button> */}
          <button
            className="text-red-600 hover:text-indigo-900 cursor-pointer mx-1"
            onClick={(e) => {
              e.preventDefault();
              navigate(`/validators/delete-validator?user=${row.id}`);
            }}
          >
            <Trash2 />
            <span className="sr-only">Delete profile for {row.name}</span>
          </button>
        </>
      ),
    },
  ];

  const today = new Date().toLocaleDateString("en-GB", {
    weekday: "long",
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const fetchValidators = async () => {
    try {
      setLoading(true);
      let response = await getAllUsers([3, null, [user.id]]); // Make sure 'user.id' is lowercase if that's correct

      let tempValidators = validatorData
        .slice(0, response.length)
        .map((data, index) => {
          const validatorUser = response[index];

          return {
            ...data,
            ...validatorUser,
            name: validatorUser.displayName || data.name,
            email: validatorUser.email,
            contactNumber: validatorUser.contactNumber,
            userId: validatorUser.id,
            role: validatorUser.userRole?.value || "",
          };
        });
      console.log(tempValidators);
      setValidators(tempValidators);
      setLoading(false);
    } catch (error) {
      console.error("Failed to load company data:", error);
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchValidators();
    // fetchStats(); // Uncomment when API is ready
  }, []);

  return (
    <div className="py-8 px-[5rem] bg-[#fbfbfb] w-screen mx-auto">
      <Header title="Validator's Settings" date={today} />
      <div className="flex space-x-4 mb-8">
        {/* Manager's Settings */}
        <div
          className="bg-white rounded-lg border border-gray-300 shadow-sm p-6 content-center text-center h-[200px] w-[300px] cursor-pointer"
          onClick={() => navigate("/validators/change-password-list")}
        >
          <h3 className="text-2xl font-semibold text-blue-500">
            Change Password
          </h3>
        </div>

        {/* Validator's Settings  /validators/add*/}
        <div
          className="bg-white rounded-lg border border-gray-300 shadow-sm p-6 content-center text-center h-[200px] w-[300px] cursor-pointer"
          onClick={() => navigate("/validators/add")}
        >
          <h3 className="text-2xl font-semibold text-blue-500">
            Add Validator
          </h3>
        </div>

        {/* Validator's Settings */}
        <div
          className="bg-white rounded-lg border border-gray-300 shadow-sm p-6 content-center text-center h-[200px] w-[300px] cursor-pointer"
          onClick={() => navigate("/validators/remove-list")}
        >
          <h3 className="text-2xl font-semibold text-blue-500">
            Remove Validator
          </h3>
        </div>
      </div>
      <div className="mb-8">
        <h2 className="text-xl font-semibold mb-2">Validators</h2>
        <p className="text-sm mb-4 text-gray-500">
          Total: {validators.length} Validators
        </p>
        <Table columns={columns} rows={validators} colour="#c5cdfb" />
      </div>
    </div>
  );
}

export default ValidatorsSettings;
